export enum MainPaths {
  INDEX = "/news",
  EDIT = "/edit_post/:id",
}
